module.exports = __webpack_public_path__ + "img/lv5.739d00df.png";